import { PlaceImage, Title } from '@/components'
import React from 'react'
import International from "../../../assets/Image/home-img/our-services/international-tours.png"
import Domestic from "../../../assets/Image/home-img/our-services/domestic-tour.png"
import HotelBooking from "../../../assets/Image/home-img/our-services/hotel-booking.png"
import FlightBooking from "../../../assets/Image/home-img/our-services/flight-booking.png"
import Pilgrimage from "../../../assets/Image/home-img/our-services/pilgrimage-tour.png"
import carRental from "../../../assets/Image/home-img/our-services/car-rental.png";
import Cruise from "../../../assets/Image/home-img/our-services/Cruise2.jpg";
export const DreamTrip = () => {
  return (
    <div className='container'>
      <Title header='Our Services—Your Gateway to the World' subtitle="Your Dream Trip Awaits Find Your Perfect Tour!" />
      <div className='flex lg:flex-row flex-col gap-4 h-full w-full'>
        <div className='flex flex-col gap-4 h-full w-full'>
          <PlaceImage img={International} imgtitle='International Tours' navigation="/international-tour" aspectRatio='800/480' />
          <PlaceImage img={Domestic} imgtitle='Domestic Tours' navigation="/domestic-tour" aspectRatio='800/364' />
        </div>
        <div className='flex flex-col gap-4 h-full w-full'>
          <div className='flex gap-4 sm:flex-row flex-col'>
            <PlaceImage img={HotelBooking} imgtitle='Hotel Booking' navigation="/hotel-booking" aspectRatio='440/400' />
            <PlaceImage img={FlightBooking} imgtitle='Flight Booking' navigation="/flight-booking" aspectRatio='440/400' />
          </div>
          <PlaceImage img={Pilgrimage} imgtitle='Pilgrimage Tours' navigation="/pilgrimage-tour" aspectRatio='900/550' />
        </div>
      </div>
      <div className="mt-4 flex lg:flex-row flex-col gap-4 h-full w-full">

        <PlaceImage
          img={Cruise}
          imgtitle="Cruise Planing"
          navigation="/cruise"
          aspectRatio="800/364"
        />

        <PlaceImage
          img={carRental}
          imgtitle="Car Rental"
          navigation="/car-rental"
          aspectRatio="800/364"
        />

      </div>
    </div>
  )
}
